import 'twin.macro';
import 'styled-components/macro';
import { gql } from '@apollo/client';

import { Button } from 'play/atoms/button/Button';
import { Modal, ModalBody, ModalFooter } from 'play/molecules/modal/Modal';
import { ProgressModalChallengeFragment, TrackStatus } from 'types/graphql';

import { ChallengeItem } from './ChallengeItem';

gql`
  fragment ProgressModalChallenge on Challenge {
    id
    status
    slug
    title
    permalink
    failed
    type
    index
  }

  fragment ProgressModalTrack on Track {
    id
    slug
    status
    median_starttime
  }
`;

interface ProgressModalProps {
  trackStatus: TrackStatus | null;
  skippingEnabled: boolean;
  challenges: ProgressModalChallengeFragment[];
  currentChallengeId?: string;
  open: boolean;
  onClose?: () => void;
  onRestart?: () => void;
  onView?: (challenge: ProgressModalChallengeFragment) => void;
  onSkip?: (challenge: ProgressModalChallengeFragment) => void;
  onContinue?: (challenge: ProgressModalChallengeFragment) => void;
  loading: boolean;
}

const TOOLTIP_CONTENT = "You can't perform this action, environment is still being created...";

export const ProgressModal = ({
  trackStatus,
  skippingEnabled,
  challenges,
  currentChallengeId,
  open,
  onClose,
  onRestart,
  onView,
  onSkip,
  onContinue,
  loading,
}: ProgressModalProps) => (
  <Modal title="Progress" width="large" onClose={onClose} open={open}>
    <ModalBody tw="max-h-[300px]">
      {challenges.map(c => (
        <ChallengeItem
          key={c.id}
          title={c.title}
          status={c.status}
          slug={c.slug}
          trackStatus={trackStatus}
          skippingEnabled={skippingEnabled}
          onView={() => onView?.(c)}
          onSkip={() => onSkip?.(c)}
          onContinue={() => onContinue?.(c)}
          inCurrentChallenge={c.id === currentChallengeId}
          loading={loading}
          envBusyTooltip={TOOLTIP_CONTENT}
        />
      ))}
    </ModalBody>

    <ModalFooter>
      <Button variant="outline" onClick={onRestart}>
        Restart
      </Button>
    </ModalFooter>
  </Modal>
);
